import { ApolloError } from '@apollo/client';
import type { User } from '@zoopla/user-queries';

export enum ACTION_TYPES_USER {
    GET_USER_ATTEMPT = 'user/GET_USER_ATTEMPT',
    GET_USER_SUCCESS = 'user/GET_USER_SUCCESS',
    GET_USER_FAILURE = 'user/GET_USER_FAILURE',
    SET_LOGGED_IN = 'user/SET_LOGGED_IN',
    SET_USER = 'user/SET_USER'
}

type Error = ApolloError | string;

export type SessionData = Pick<
    User,
    | 'loggedIn'
    | 'status'
    | 'senderPropertyStatus'
    | 'userId'
    | 'userUuid'
    | 'creationDate'
    | 'brandPrimary'
    | 'registrationSources'
    | 'registered'
>;

export type LoggedInStatus =
    | 'initial'
    | 'loading'
    | 'isLoggedIn'
    | 'isNotLoggedIn'
    | 'error';

export type SessionState = {
    loading: boolean;
    loggedInStatus: LoggedInStatus;
    error: Error[];
} & SessionData;

interface GetUserAttemptAction {
    type: typeof ACTION_TYPES_USER.GET_USER_ATTEMPT;
}
interface GetUserSuccessAction {
    type: typeof ACTION_TYPES_USER.GET_USER_SUCCESS;
    user?: SessionData;
}
interface GetUserFailureAction {
    type: typeof ACTION_TYPES_USER.GET_USER_FAILURE;
    error: Error;
}
interface SetLoggedInAction {
    type: typeof ACTION_TYPES_USER.SET_LOGGED_IN;
    isLoggedIn: boolean;
}
interface SetUserAction {
    type: typeof ACTION_TYPES_USER.SET_USER;
    user: User;
}

export type UserActionTypes =
    | GetUserAttemptAction
    | GetUserSuccessAction
    | GetUserFailureAction
    | SetLoggedInAction
    | SetUserAction;
